import React from 'react';

import { useGridApiContext } from '@mui/x-data-grid';
import { FormControl, MenuItem, Select } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import { getSystemTypesOptions } from 'common/utils/helpers';

const CustomSystemEditField = (props) => {
    const { id, field, systemTypes, value } = props;
    const apiRef = useGridApiContext();

    const handleChange = (event) => {
        apiRef.current.setEditCellValue({
            id,
            field,
            value: event.target.value,
        });
    };
    const options = getSystemTypesOptions(systemTypes);
    return (
        <FormControl fullWidth>
            <Select
                labelId="system-select-label"
                id="system-select"
                value={value}
                onChange={handleChange}
                variant="standard"
                sx={{
                    '& .MuiSelect-select': {
                        alignItems: 'center',
                        display: 'flex',
                        gap: 1,
                    },
                }}
            >
                {options.map(({ label, value }) => (
                    <MenuItem
                        key={`option-${value}`}
                        value={value}
                        sx={{ alignItems: 'center', display: 'flex', gap: 1 }}
                    >
                        {label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

CustomSystemEditField.propTypes = {
    field: PropTypes.string,
    id: PropTypes.string,
    systemTypes: PropTypes.array,
    value: PropTypes.string,
};

export default CustomSystemEditField;
